(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33421],{

/***/ 141342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SGCFrequentlyBoughtTogether; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(423942);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(309396);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(534090);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(329706);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(504133);
/* harmony import */ var hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(725530);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(859676);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












const SGCFrequentlyBoughtTogether = ()=>{
    const { isMobile , contactLink , isAllowATCFromListing , isDisplayUom , showNewProductGift ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useCartV2 */ .T6)();
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useServices */ .Su)();
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useProductDetailState */ .W)();
    const { transformProductWhenUserUnder18  } = (0,hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_8__/* .useHandlerUnderEighteenYearOld */ .x)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .aC)();
    const { productHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useHelper */ .H)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        cartV2,
        showNewProductGift,
        hideHighlightAttribute: (0,helpers__WEBPACK_IMPORTED_MODULE_11__/* .isHomepage */ .GH)(router.asPath),
        enableTrackOpenInNewTab: router.asPath.includes("/search") || router.asPath.includes("/c/")
    };
    const transformProduct = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((product)=>{
        var ref, ref1, ref2, ref3;
        return transformProductWhenUserUnder18(productHelper.convertNewProductCard(product, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
            wishlistButton: {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_12__/* .WishlistButton */ .s, {
                    sku: (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.sku
                })
            },
            bestComboDiscount: product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.bestComboDiscount,
            benefitLabel: product === null || product === void 0 ? void 0 : (ref3 = product.productInfo) === null || ref3 === void 0 ? void 0 : ref3.benefitLabel
        })));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(cartV2.flattenItems),
        authLoading
    ]);
    const { data: recommendationsProducts = []  } = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        "/products/".concat(product === null || product === void 0 ? void 0 : product.sku, "/recommendations")
    ], async ()=>{
        const response = await discoveryService.getRecommendedSkus((product === null || product === void 0 ? void 0 : product.sku) || "");
        return response || [];
    }, {
        revalidateOnFocus: false,
        shouldRetryOnError: false
    });
    if (!(recommendationsProducts === null || recommendationsProducts === void 0 ? void 0 : recommendationsProducts.length)) return null;
    const arrowStyle = {
        backgroundColor: "white",
        borderRadius: 999,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HorizontalProductWrapper, {
        isMobile: isMobile,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__/* .ProductCarouselWithHeader */ .B, {
            header: {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Hay được mua c\xf9ng"),
                style: {
                    height: "".concat(isMobile ? "2.75rem" : "2.8rem"),
                    alignItems: "flex-end"
                }
            },
            products: recommendationsProducts === null || recommendationsProducts === void 0 ? void 0 : recommendationsProducts.map(transformProduct),
            productsPerRow: isMobile ? 2.3 : 6.5,
            dividerColor: "divider",
            regionName: "recommendProducts",
            style: {
                minHeight: "auto"
            },
            customStyleLeftArrow: arrowStyle,
            customStyleRightArrow: arrowStyle,
            desktopProps: {
                perSwipe: "",
                bound: true
            }
        })
    });
};
const HorizontalProductWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div((param)=>{
    let { isMobile  } = param;
    return "\n  background: #fff;\n  margin-top: 8px;\n  border-radius: 16px;\n\n  .wrapper-horizontal-slider {\n    padding: 0px 8px;\n  }\n\n  .title {\n  ".concat(isMobile ? "font-size: 18px;\n    line-height: 24px;" : "font-size: 20px;\n    line-height: 28px;", "\n    \n    font-weight: 700;\n  }\n");
});


/***/ }),

/***/ 926380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SGCFrequentlyBoughtTogether": function() { return /* reexport */ SGCFrequentlyBoughtTogether/* SGCFrequentlyBoughtTogether */.U; },
  "getServerSidePropsDetail": function() { return /* reexport */ getServerSidePropsDetail; }
});

// EXTERNAL MODULE: ./modules/product-detail/shared/SGCFrequentlyBoughtTogether.tsx
var SGCFrequentlyBoughtTogether = __webpack_require__(141342);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Currency/Currency.es.js
var Currency_es = __webpack_require__(853675);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./helpers/service-provider.ts + 20 modules
var service_provider = __webpack_require__(568915);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./server/redis-client.ts
var redis_client = __webpack_require__(279106);
;// CONCATENATED MODULE: ./modules/product-detail/shared/getServerSideProps.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const convertDiscoveryPrice = (price)=>{
    if (!price) return null;
    return _objectSpreadProps(_objectSpread({
        price: price.price
    }, price.discount ? {
        discountPercent: "-".concat(price.discount, "%")
    } : {}), {
        displayRowTotal: price.price && (0,Currency_es/* formatCurrency */.xG)(price.price, {
            underline: true
        }),
        strikeThroughDisplayRowTotal: price.sellPrice && (0,Currency_es/* formatCurrency */.xG)(price.sellPrice, {
            underline: true
        }),
        promotions: []
    });
};
const getServerSidePropsDetail = async (context)=>{
    try {
        var ref, ref1;
        const { productId , sku  } = context.params || {};
        const tenantEnv = context.req.tenantEnv;
        const terminalCode = context.req.terminal;
        if (!terminalCode) {
            throw new Error("no terminal");
        }
        const location = context.req.location;
        const { discoveryService , cartServiceV2 , discoveryServiceV2 , discoveryHelper ,  } = new service_provider/* ServiceContainer */.h(tenantEnv);
        const requestParams = {
            productId: productId,
            sku: sku || context.query.sku,
            terminalCode,
            location
        };
        const product = await discoveryService.getProduct(requestParams);
        if ((product === null || product === void 0 ? void 0 : product.productInfo.canonical) && context.req.path !== "/".concat(encodeURI(product.productInfo.canonical)) && !context.req.path.endsWith(".json")) {
            const url = context.req.url;
            const query = url && url.indexOf("?") >= 0 ? url.substring(url.indexOf("?")) : "";
            return {
                props: {},
                redirect: {
                    permanent: true,
                    destination: "/".concat(encodeURI(product.productInfo.canonical)).concat(query)
                }
            };
        }
        const getRelatedProducts = async ()=>{
            var ref;
            const productCategories = product === null || product === void 0 ? void 0 : (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.categories;
            const response = await discoveryServiceV2.search(tenantEnv.passSkuToReturnSimilarProducts ? {
                page: 1,
                pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
                filter: {
                    skuToReturnSimilarProducts: sku
                }
            } : !!(productCategories === null || productCategories === void 0 ? void 0 : productCategories.length) && !!(product === null || product === void 0 ? void 0 : product.productInfo.sku) ? {
                page: 1,
                pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
                filter: {
                    excludedSkus: [
                        product === null || product === void 0 ? void 0 : product.productInfo.sku
                    ],
                    categoryIds: [
                        productCategories[productCategories.length - 1].id, 
                    ]
                }
            } : {});
            const relatedProducts = (response === null || response === void 0 ? void 0 : response.products) || [];
            return relatedProducts.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product));
        };
        const getPriceAndPromotion = async ()=>{
            try {
                return await cartServiceV2.getPriceAndPromotion(sku || context.query.sku, {
                    quantity: 1
                });
            } catch (e) {
                index_es/* logger.error */.k.error(context.req, e);
            }
        };
        const [relatedProducts, dataCalculatePrice, breadcrumbs] = await Promise.all([
            getRelatedProducts(),
            getPriceAndPromotion(),
            getBreadcrumbs("".concat((ref = context.req.tenantEnv.platformId) === null || ref === void 0 ? void 0 : ref.toString(), "_").concat(productId || ((ref1 = product === null || product === void 0 ? void 0 : product.productDetail.productGroup) === null || ref1 === void 0 ? void 0 : ref1.id))), 
        ]);
        return {
            props: {
                serverProduct: {
                    product,
                    relatedProducts,
                    breadcrumbs,
                    priceAndPromotions: dataCalculatePrice || convertDiscoveryPrice((0,discovery/* convertProductDetail */.NP)(product).price)
                },
                key: sku || productId
            }
        };
    } catch (e) {
        index_es/* logger.error */.k.error(context.req, e);
        return {
            notFound: true
        };
    }
};
const getBreadcrumbs = async (redisKey)=>{
    const collection = await (0,redis_client/* fromRedisCache */.nr)("BREADCRUMB", redisKey, async ()=>undefined, redis_client/* REDIS_DEFAULT_EXPIRED */.gs);
    if (!collection) return [];
    const breadcrumbs = collection.breadcrumbs.map((br)=>({
            name: br.label,
            link: br.url || "#"
        }));
    return breadcrumbs;
};

;// CONCATENATED MODULE: ./modules/product-detail/shared/index.ts




/***/ }),

/***/ 279106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aP": function() { return /* binding */ redisGroupKey; },
/* harmony export */   "gs": function() { return /* binding */ REDIS_DEFAULT_EXPIRED; },
/* harmony export */   "nr": function() { return /* binding */ fromRedisCache; }
/* harmony export */ });
/* unused harmony exports REDIS_DEFAULT_TIMEOUT, RedisInstance, promiseTimeout */
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var redis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(958859);
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77335);
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(960387);



const redisGroupKey = {
    SELLER: "SELLER",
    MASTER_CAT: "MASTER_CAT",
    CRON_JOB: "CRON_JOB",
    SELLER_CAT: "SELLER_CAT",
    MAPPING_SELLER_CAT_PRODUCTS: "MAPPING_SELLER_CAT_PRODUCTS",
    MENU_ITEMS: "MENU_ITEMS",
    SITEMAP: "SITEMAP",
    COLLECTIONS: "COLLECTIONS",
    CATEGORIES: "CATEGORIES",
    ARTICLES: "ARTICLES",
    PRODUCTS_CATEGORY: "PRODUCTS_CATEGORY",
    PRODUCTS_COLLECTION: "PRODUCTS_COLLECTION",
    PRODUCTS: "PRODUCTS",
    LANDING: "LANDING",
    LAYOUT: "LAYOUT",
    BREADCRUMB: "BREADCRUMB",
    FEATURE_FLAG: "FEATURE_FLAG",
    FIXED_PRODUCT_VARIANTS: "FIXED_PRODUCT_VARIANTS"
};
const REDIS_DEFAULT_TIMEOUT = 3000;
const REDIS_DEFAULT_EXPIRED = 24 * 60 * 60; // 1 day
class RedisInstance {
    static getInstance() {
        if (!this.redisInstance) {
            this.redisInstance = new RedisInstance();
        }
        return this.redisInstance;
    }
    asyncFn(fn) {
        return (0,util__WEBPACK_IMPORTED_MODULE_2__.promisify)(fn).bind(this.redisClient);
    }
    getInstance() {
        return this.redisClient;
    }
    computeKeyName(group, key) {
        if (!redisGroupKey[group]) return null;
        return "".concat(redisGroupKey[group], ":").concat(key);
    }
    // default redis key is computed as group:key
    setValue(group, key, value) {
        let timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : REDIS_DEFAULT_TIMEOUT, expired = arguments.length > 4 ? arguments[4] : void 0;
        const computedKey = this.computeKeyName(group, key);
        if (!computedKey) return null;
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:set:".concat(computedKey));
        const args = expired ? [
            computedKey,
            value,
            "EX",
            expired
        ] : [
            computedKey,
            value
        ];
        return promiseTimeout(this.asyncFn(this.redisClient.set)(...args), timeout);
    }
    msetValue(group, keyValues) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT, expired = arguments.length > 3 ? arguments[3] : void 0, logId = arguments.length > 4 ? arguments[4] : void 0;
        let args = [];
        Object.entries(keyValues).forEach((param)=>{
            let [key, value] = param;
            const computedKey = this.computeKeyName(group, key);
            if (computedKey) {
                args = [
                    ...args,
                    computedKey,
                    value
                ];
            }
        });
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("".concat(logId ? "[".concat(logId, "] ") : "", "redis:mset:").concat(args.map((arg, index)=>index % 2 === 0 && arg).filter((arg)=>!!arg)));
        if (expired) {
            args = [
                ...args,
                "EX",
                expired.toString()
            ];
        }
        return promiseTimeout(this.asyncFn(this.redisClient.mset)(...args), timeout, logId);
    }
    deleteValueByKeys(keys) {
        let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : REDIS_DEFAULT_TIMEOUT;
        if (keys.length < 1) return new Promise((resolve)=>resolve(null));
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:del:".concat(keys));
        return promiseTimeout(this.asyncFn(this.redisClient.del)(...keys), timeout);
    }
    getValue(group, key) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        const computedKey = this.computeKeyName(group, key);
        if (!computedKey) return null;
        return promiseTimeout(this.asyncFn(this.redisClient.get)(computedKey), timeout);
    }
    mgetValue(group, keys) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        const computedKeys = keys.map((key)=>this.computeKeyName(group, key)).filter((key)=>!!key);
        if (computedKeys.length < 1) return new Promise((resolve)=>resolve([]));
        return promiseTimeout(this.asyncFn(this.redisClient.mget)(...computedKeys), timeout);
    }
    hashSetValue(group, keyValue) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        if (!redisGroupKey[group]) return null;
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.info */ .k.info("redis:hmset:".concat(redisGroupKey[group], ":").concat(Object.keys(keyValue).join(",")));
        return promiseTimeout(this.asyncFn(this.redisClient.hmset)(redisGroupKey[group], keyValue), timeout);
    }
    hashGetValue(group, key) {
        let timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REDIS_DEFAULT_TIMEOUT;
        if (!redisGroupKey[group]) return null;
        return promiseTimeout(this.asyncFn(this.redisClient.hget)(redisGroupKey[group], key), timeout);
    }
    getKeysByPattern(pattern) {
        let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : REDIS_DEFAULT_TIMEOUT;
        return promiseTimeout(this.asyncFn(this.redisClient.keys)(pattern), timeout);
    }
    constructor(){
        this.redisClient = redis__WEBPACK_IMPORTED_MODULE_1__.createClient({
            host: process.env.REDIS_HOST,
            port: process.env.REDIS_PORT ? Number(process.env.REDIS_PORT) : 6379,
            db: process.env.REDIS_DB ? Number(process.env.REDIS_DB) : 0,
            retry_strategy: (options)=>{
                if (options.attempt > 4) return new Error("Redis server refused the connection");
                // reconnect after 1 minutes
                return 60000;
            }
        });
        this.redisClient.on("error", _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error);
    }
}
/**
 * This function is only called in server
 */ const fromRedisCache = async function(groupKey, key, getData) {
    let expiredTime = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : REDIS_DEFAULT_EXPIRED, noCache = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const redisInstance = RedisInstance.getInstance();
    const fetchData = async ()=>{
        return getData().then((result)=>{
            try {
                if (Array.isArray(result) && result.length > 0 || !Array.isArray(result) && result) {
                    redisInstance.setValue(groupKey, key, JSON.stringify(result), REDIS_DEFAULT_TIMEOUT, expiredTime);
                }
            } finally{
                return result;
            }
        });
    };
    try {
        const cacheData = await redisInstance.getValue(groupKey, key);
        return cacheData && !noCache ? JSON.parse(cacheData) : fetchData();
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
        return fetchData();
    }
};

/**
 *
 * @param promise
 * @param timeout: in milliseconds
 */ const promiseTimeout = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
promise, timeoutMillis, logId)=>{
    let timeoutFn;
    return Promise.race([
        promise,
        new Promise((_, reject)=>{
            timeoutFn = setTimeout(()=>{
                const errorMessage = "".concat(logId ? "[".concat(logId, "] ") : "", "Time limit exceeded ").concat(timeoutMillis, "ms");
                _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(errorMessage);
                reject(new Error(errorMessage));
            }, timeoutMillis);
        }), 
    ]).then((v)=>{
        clearTimeout(timeoutFn);
        return v;
    }).catch((err)=>{
        clearTimeout(timeoutFn);
        throw err;
    });
};


/***/ }),

/***/ 562333:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 902134:
/***/ (function() {

/* (ignored) */

/***/ })

}]);